<template>
  <uniBadge class="badge-cart" size="small" :text="cartText" absolute="rightTop" type="error">
    <uni-icons size="32" type="icomoon-cart"></uni-icons>
  </uniBadge>
</template>

<script>
import uniBadge from "@/components/uni-badge/uni-badge.vue";
import {
		mapState,
    mapMutations,
	} from 'vuex';
// import { getCartLength } from "@/utils/getCartLen.js";

export default {
  name: "CartCount",
  components: { uniBadge },
  computed: {
    ...mapState(['cartText'])
  },
  mounted() {
    // this.updateCartText();
  },
  methods: {
    ...mapMutations(["updateCartText"])
  },
};
</script>

<style lang="scss" scoped>
</style>
